/**
 * Permission tree for Permissions page UI. Built from sidebar + subtabs (single source of truth).
 * See sidebarPermissionConfig.js for the full structure.
 */
import { SIDEBAR_PERMISSION_STRUCTURE } from "./sidebarPermissionConfig";

export const permissionsData = SIDEBAR_PERMISSION_STRUCTURE;
